(function () {
  // Shoplift A/B: the new selector markup is rendered for everyone so both variants get identical
  // HTML from the server, and only variant B is activated. snippets/shoplift-api-live.liquid adds
  // the class and fires the event once Shoplift has resolved the bucket.
  const AB_CLASS = 'tlc-selector-b';
  const AB_EVENT = 'tlc:selector-ab';
  const isVariantB = () => document.documentElement.classList.contains(AB_CLASS);

  class VariantSheet {
    constructor() {
      document.addEventListener("click", this.handleClick.bind(this));
      document.addEventListener("input", this.handleInput.bind(this));
      document.addEventListener("change", this.handleChange.bind(this));
      document.addEventListener("keydown", this.handleKeydown.bind(this));
      document.addEventListener("variant:update", () => this.enhanceAll());
      document.addEventListener(AB_EVENT, () => this.enhanceAll());
      this.enhanceAll();
    }

    open(root) {
      if (!root) return;
      root.classList.add("is-open");
      root.querySelector("[data-variant-sheet-trigger]")?.setAttribute("aria-expanded", "true");
      document.documentElement.setAttribute("scroll-lock", "");
    }

    close(root) {
      if (!root) return;
      root.classList.remove("is-open");
      root.querySelector("[data-variant-sheet-trigger]")?.setAttribute("aria-expanded", "false");
      if (!document.querySelector("[data-variant-sheet-root].is-open")) {
        document.documentElement.removeAttribute("scroll-lock");
      }
    }

    handleClick(event) {
      // The control renders the same markup but keeps the sheet display:none, so every
      // handler stays inert for it - same rule as enhanceAll() and the wrapper's gated CSS.
      if (!isVariantB()) return;
      const categoryTab = event.target.closest("[data-category-tab]");
      if (categoryTab) {
        this.setActiveCategory(categoryTab);
        return;
      }

      const trigger = event.target.closest("[data-variant-sheet-trigger]");
      if (trigger) {
        this.open(trigger.closest("[data-variant-sheet-root]"));
        return;
      }

      const closer = event.target.closest("[data-variant-sheet-close], [data-variant-sheet-backdrop]");
      if (closer) {
        this.close(closer.closest("[data-variant-sheet-root]"));
      }
    }


    setActiveCategory(tab) {
      const root = tab.closest("[data-variant-sheet-root]");
      if (!root) return;
      const category = tab.getAttribute("data-category-tab");

      root.querySelectorAll("[data-sheet-category-tabs] [data-category-tab]").forEach((btn) => {
        btn.classList.toggle("active", btn.getAttribute("data-category-tab") === category);
      });
      this.updateVisibility(root);
    }

    updateVisibility(root) {
      const list = root.querySelector("[data-variant-sheet-options]");
      if (!list) return;

      const query = root.querySelector("[data-variant-sheet-search]")?.value.trim().toLowerCase() || "";
      const activeCategory = root.querySelector("[data-sheet-category-tabs] [data-category-tab].active")
        ?.getAttribute("data-category-tab");

      const labels = list.querySelectorAll("label:has(input)");
      let visibleCount = 0;

      labels.forEach((label) => {
        const name = label.querySelector("input")?.getAttribute("aria-label") || "";
        const matchesSearch = !query || name.toLowerCase().includes(query);
        const panelCategory = label.closest("[data-category-panel]")?.getAttribute("data-category-panel");
        const inActiveCategory = query.length > 0 || !panelCategory || panelCategory === activeCategory;
        const visible = matchesSearch && inActiveCategory;
        label.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      const empty = root.querySelector("[data-variant-sheet-empty]");
      if (empty) empty.hidden = labels.length === 0 || visibleCount !== 0;
    }

    handleChange(event) {
      // The control's own swatches sit inside the panel (display:contents for variant A),
      // so without this they would call close() and strip scroll-lock from an open dialog.
      if (!isVariantB()) return;
      if (!event.target.closest("[data-variant-sheet-options]")) return;
      this.close(event.target.closest("[data-variant-sheet-root]"));
    }

    handleKeydown(event) {
      if (!isVariantB()) return;
      if (event.key !== "Escape") return;
      this.close(document.querySelector("[data-variant-sheet-root].is-open"));
    }

    handleInput(event) {
      if (!isVariantB()) return;
      if (!event.target.matches("[data-variant-sheet-search]")) return;
      const root = event.target.closest("[data-variant-sheet-root]");
      if (root) this.updateVisibility(root);
    }

    enhanceAll() {
      if (!isVariantB()) return;

      document.querySelectorAll("[data-variant-sheet-options]").forEach((list) => this.enhance(list));
      document.querySelectorAll("[data-sheet-category-tabs]").forEach((tabs) => this.initCategoryTabs(tabs));
    }

    initCategoryTabs(tabs) {
      const root = tabs.closest("[data-variant-sheet-root]");
      if (!root || tabs.querySelector("[data-category-tab].active")) return;

      const checkedInput = root.querySelector("[data-variant-sheet-options] input:checked");
      const checkedCategory = checkedInput?.closest("[data-category-panel]")?.getAttribute("data-category-panel");
      const buttons = Array.from(tabs.querySelectorAll("[data-category-tab]"));
      const defaultTab =
        buttons.find((btn) => btn.getAttribute("data-category-tab") === checkedCategory) || buttons[0];

      if (defaultTab) this.setActiveCategory(defaultTab);
    }

    /** Adds a checkmark badge + name caption to each swatch label, read-only against the real inputs. */
    enhance(list) {
      list.querySelectorAll("label:has(.swatch)").forEach((label) => {
        const input = label.querySelector("input");
        const swatch = label.querySelector(".swatch");
        if (!input || !swatch) return;

        if (!swatch.querySelector(":scope > .variant-sheet-check")) {
          const check = document.createElement("span");
          check.className = "variant-sheet-check";
          check.setAttribute("aria-hidden", "true");
          check.innerHTML =
            '<svg viewBox="0 0 16 16" width="16" height="16"><path d="M3 8.5L6.5 12L13 4.5" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          swatch.appendChild(check);
        }

        if (!label.querySelector(":scope > .variant-sheet-caption")) {
          const caption = document.createElement("span");
          caption.className = "variant-sheet-caption";
          caption.textContent = input.getAttribute("aria-label") || "";
          label.appendChild(caption);
        }
      });
    }
  }

  // The loader lists this file in more than one branch; only ever instantiate once.
  if (!window.__tlcVariantSheet) window.__tlcVariantSheet = new VariantSheet();
})();
